var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('ClipLoader',{attrs:{"loading":_vm.isLoading,"color":_vm.color,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }